import type { Tracker } from '../types/tracker';

/* eslint-disable no-console, prefer-promise-reject-errors */
export const mockTracker: Tracker = {
  init: () => {
    window.mockTracker = {
      trackMethod: () => true
    };
    console.log('Mock Tracker init', window.mockTracker);
    return true;
  },
  trackError: (error, details) => {
    if (!window.mockTracker) {
      return Promise.reject('Mock tracker was not properly initialized');
    }
    return Promise.resolve(console.log('Mock Tracker', window.mockTracker.trackMethod(), error, details));
  },
  trackEvent: (eventName, details) => {
    if (!window.mockTracker) {
      return Promise.reject('Mock tracker was not properly initialized');
    }
    return Promise.resolve(console.log('Mock Tracker', window.mockTracker.trackMethod(), eventName, details));
  }
};
/* eslint-enable no-console, prefer-promise-reject-errors */
